import { useEffect, useState } from 'react';
import { getTags } from '../api';
import { Tag } from '../types/tags';
import { flattenProducts, getTag, transformData } from '../helpers/utils';
import { useTagsStore } from '../store/tagsStore';

const useGetData = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const tags: Tag[] = await getTags();
                // provider info
                const rawProvidersTags = tags.filter((tag) => tag.entityType === "Provider");
                const providersTags: any = transformData(rawProvidersTags);
                const providerCategories = providersTags?.Proveedor?.Categorias;
                const providerMetadata = providersTags?.Proveedor?.Metadata;

                const providerTopUser = getTag(providerMetadata?.Top, 'Proveedor Top') ?? null;
                const providerVerifiedUser = getTag(providerMetadata?.Verificado, 'Proveedor Verificado') ?? null;

                const providerLocation = providerMetadata?.Localizacion;

                //product info
                const rawProductsTags = tags.filter((tag) => tag.entityType === "Product");

                const productsTags: any = transformData(rawProductsTags);
                const productsFlatTags = flattenProducts(productsTags);

                const productCategories = productsTags?.Producto?.Categorias;

                const {
                    setTags,
                    setProvidersTags,
                    setProductsTags,
                    setProviderCategories,
                    setProviderMetadata,
                    setProviderTopUser,
                    setProviderVerifiedUser,
                    setProviderLocation,
                    setProductCategories,
                    setSubProductosTags
                } = useTagsStore.getState();

                setTags(tags);
                setProvidersTags(providersTags);
                setProductsTags(productsTags);
                setProviderCategories(providerCategories);
                setProviderMetadata(providerMetadata);
                setProviderTopUser(providerTopUser);
                setProviderVerifiedUser(providerVerifiedUser);
                setProviderLocation(providerLocation);
                setProductCategories(productCategories);
                setSubProductosTags(productsFlatTags);
            } catch (error) {
                console.error('Error fetching token:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTags();
    }, []);
    return { isLoading };
};

export default useGetData;
